import { gql } from '@apollo/client';
import { ADDRESS_FIELDS } from '../address';
import { BILLING_FIELDS } from '../billing/billing.fields';
import { DEPARTMENT_DETAIL_FIELDS } from '../department';
import { ORGANIZATION_FIELDS } from './organization.fields';
import { CONTACT_FIELDS } from '../contact';
import { STAFF_FIELDS } from '../staff';

export const ORGANIZATION_DETAIL_FIELDS = gql`
  ${ADDRESS_FIELDS}
  ${BILLING_FIELDS}
  ${DEPARTMENT_DETAIL_FIELDS}
  ${ORGANIZATION_FIELDS}
  ${CONTACT_FIELDS}
  ${STAFF_FIELDS}
  fragment OrganizationDetailFields on Organization {
    ...OrganizationFields
    address {
      ...AddressFields
    }
    billing {
      ...BillingFields
    }
    departments {
      ...DepartmentDetailFields
    }
    contact {
      ...ContactFields
    }
  }
`;
